import { ShowIconPipe } from '../pipes/show-icon.pipe';
import { IsNilPipe } from 'src/app/pipes/is-nil.pipe';

import { CommonModule } from '@angular/common';
import {
  Component,
  inject,
  input,
  OnInit,
  output,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

export const MODULES = [
  CommonModule,
  MatIconModule,
  MatButtonModule,
  MatTooltipModule,
  MatFormFieldModule,
];
export const COMPONENTS = [FaIconComponent];
export const PIPES = [ShowIconPipe, IsNilPipe];

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.Emulated,
  imports: [...MODULES, ...COMPONENTS, ...PIPES],
})
export class StarRatingComponent implements OnInit {
  private snackBar = inject(MatSnackBar);

  rating = input<number>(3);
  starCount = input<number>(5);
  color = input<string>('accent');
  disableInput = input<boolean>(false);
  clearButton = input<boolean>(false);
  ratingUpdated = output<number>();

  public snackBarDuration = 2000;
  public ratingArr = signal<number[]>([]);

  ngOnInit(): void {
    for (let index = 0; index < this.starCount(); index++) {
      this.ratingArr.update(ratingArr => {
        return [...ratingArr, index];
      });
    }
  }
  onClick(rating: number): boolean {
    if (!this.disableInput()) {
      this.snackBar.open(
        'Sie haben ' + rating + ' / ' + this.starCount() + ' gewählt.',
        '',
        {
          duration: this.snackBarDuration,
        }
      );
      this.ratingUpdated.emit(rating);
      return false;
    }
  }
}
export enum StarRatingColor {
  primary = 'primary',
  accent = 'accent',
  warn = 'warn',
}
